(() => {
  const sky = document.getElementById('dear-jupiter-header-sky');
  if (!sky) return;
  const positionSky = () => {
    const header = document.querySelector('.section-header');
    if (!header) {
      sky.removeAttribute('data-positioned');
      return;
    }
    if (header.previousElementSibling !== sky) header.before(sky);
    sky.setAttribute('data-positioned', '');
  };
  positionSky();
  document.addEventListener('shopify:section:load', positionSky);
  document.addEventListener('shopify:section:reorder', positionSky);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches('.section-header')) sky.removeAttribute('data-positioned');
  });
})();
